module.exports = __webpack_public_path__ + "img/gw-cart.ff3a1fd8.png";